import React, { Component } from 'react';
import {Container, Segment, Header, Image, Message} from 'semantic-ui-react';

export default class AboutComponent extends Component {

    render() {
        return (
            <Container>
                <Header as='h2' attached='top'>
                    About the Site
                </Header>
                <Segment attached>
                    <p>
                        Thank you for visiting our site.  TelaraDb is the continued creation of a small team of dedicated gamers with a passion around data mining, aggregation, and presentation.
                    </p>
                    <p>
                        This site is the product of lots of hard work and late nights.  We hope you find it useful, and if there's a problem, or something is missing, we're always open to suggestions.
                    </p>
                    <p>
                        You can see what we're currently working on by visiting TelaraDb's <a href='https://trello.com/b/PzOu3yyv' target="_blank" rel="noopener noreferrer">Trello Board</a>.
                        If you'd like to participate in the discussion of TelaraDb, please feel free to join our <a href='https://discord.gg/YypJTPn'>public Discord channel at the Ghar Station.</a>
                    </p>
                </Segment>

                <Header as='h2' attached='top'>
                    About Us
                </Header>
                <Segment attached style={{marginBottom: '4rem'}}>
                    <Segment vertical>
                        <Header as='h3'>
                            <Image bordered circular src='https://s.gravatar.com/avatar/42c7463dd19e08074913dadd5a2694dc' /> JosuaLackhand
                        </Header>
                        <p>
                            Site developer for TelaraDb.  He aggregates the data provided by data mining team, pretties it up and makes it easy to search and view.  He has been gaming since early 80's, and building software for just as long.
                        </p>
                    </Segment>
                    <Segment vertical>
                        <Header as='h3'>
                            clowd
                        </Header>
                        <p>
                        The owner, writer, and maintainer of <a href='https://thegharstation.com'>The Ghar Station</a>.  He runs the discord, helps datamine Rift, writes all the articles and works as the face of The Ghar Station for everything external to that Site.  He has been playing Rift on/off since Beta 2!
                        </p>
                        <p>
                          Here at TelaraDb, he uses his data mining prowess to provide many of the formulas driving item information, as well as providing key insight on many different aspects of the Rift data.
                        </p>
                    </Segment>
                    <Segment vertical>
                        <Header as='h3'>
                            imathrowback
                        </Header>
                        <p>
                            Lead dataminer for Rift.  He has produced all of the modern tools that are used to datamine patches for both Live and PTS.  He is the sole developer of Telarafly, the Rift world and model viewer.  If you enjoy how detailed our datamining is, please thank him!
                        </p>
                    </Segment>
                    <Segment vertical>
                        <Header as='h3'>
                            Deathbeams
                        </Header>
                        <p>
                            A data miner and memory scraper novice, Deathbeams provides the connections between appearances and items, making the viewing of an item's model possible.
                        </p>
                    </Segment>
                </Segment>

                <Message size='small'>
                    <Message.Header>Obligatory Disclaimer</Message.Header>
                    <p>
                        Trion, Trion Worlds, RIFT, Storm Legion, Nightmare Tide, Prophecy of Ahnket, Telara, and their respective logos, are trademarks or registered trademarks of Trion Worlds, Inc. in the U.S. and other countries. TelaraDb and TelaraDb.com are not affiliated with Trion Worlds, Inc. or any of its affiliates.
                    </p>
                </Message>

                <Message size='small' style={{marginBottom: '5rem'}}>
                    <Message.Header>Privacy Policy</Message.Header>
                    <p>
                        We currently don't collect any personal information.  Consequently, there's nothing to store.  However, we do write some basic user preference details to local storage, but that's the extent of our nefarious designs.
                    </p>
                </Message>

            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/about/AboutComponent.jsx